import Card from './Card';
import FormInput from './FormInput'
import FormInputFile from './FormInputFile'
import FormInputFileName from './FormInputFileName'
import InfoCollapse from './InfoCollapse'
import TextArea from './TextArea'
import TextAreaCollapse from './TextAreaCollapse' 
import SelectInput from './SelectInput'
import SelectInputSimple from './SelectInputSimple'
import SelectCategoria from './SelectCategoria'
import Modal from './Modal'
import LoadingButton from './LoadingButton';
import LoadingScreen from './LoadingScreen';
import PageTitle from './PageTitle';
import SelectPatient from './SelectPatient';
import SelectProfesional from './SelectProfesional';
import Table from './Table';
import ZfButton from './ZfButton';
import ZfBadge from './ZfBadge';
import { ZfInput, ZfTextarea, ZfSelect } from './ZfInput';
import AvisoPrivacidad from './AvisoPrivacidad';
import CollapsibleSection from './CollapsibleSection';
import PatientPanel from './PatientPanel';
import Chip from './Chip';
import ModalidadChip from './ModalidadChip';
import { TableActions, TableActionButton } from './TableActions';

export {
    Card,
    FormInput,
    FormInputFile,
    FormInputFileName,
    InfoCollapse,
    TextArea,
    TextAreaCollapse,
    SelectInput,
    SelectInputSimple,
    SelectCategoria,
    Modal,
    LoadingButton,
    LoadingScreen,
    PageTitle,
    SelectPatient,
    SelectProfesional,
    Table,
    ZfButton,
    ZfBadge,
    ZfInput,
    ZfTextarea,
    ZfSelect,
    AvisoPrivacidad,
    CollapsibleSection,
    PatientPanel,
    Chip,
    ModalidadChip,
    TableActions,
    TableActionButton
}